import LoginSettings from '@/entities/profile-page/settingsProfile/LoginSettings'
// import FilesForDownload from "@/entities/profile-page/settingsProfile/FilesForDownload";
import { useInView } from 'react-intersection-observer'

export const SettingsProfile = () => {
    const { ref, inView } = useInView({
        threshold: 0,
        triggerOnce: true,
    })
    return (
        <div
            ref={ref}
            className={`SettingsProfile ${
                inView && `animate__animated animate__zoomInRight`
            }`}
        >
            <h2>Настройки</h2>
            <div className={'settings-content'}>
                <LoginSettings />
                {/*<FilesForDownload/>*/}
            </div>
        </div>
    )
}
